import axios from 'axios';
import { useQuery, UseQueryOptions } from './useQuery';
import { useApp } from '../designs/paper/context/AppContext';
import { CartSessionResponse } from '../../../../../shared/types/cartSession';

type UseCartSessionOptions = UseQueryOptions<CartSessionResponse, Error>;

/**
 * Hook to fetch cart session with all reservation drafts and their progress
 * @param cartSessionId - The cart session ID
 * @param options - Additional react-query options
 */
export function useCartSession(
  propertyId: string,
  cartSessionId: string,
  options?: UseCartSessionOptions
) {
  const { config } = useApp();

  return useQuery<CartSessionResponse, Error>(
    ['cartSession', propertyId, cartSessionId],
    async () => {
      const response = await axios.get<CartSessionResponse>(
        config.cartSessionUrl.replace(':cartId', cartSessionId)
      );
      return response.data;
    },
    options
  );
}
